
import { Grid, TextField } from '@mui/material'
import { useForm } from '../../../hooks';
import { useState } from 'react';
import { BotonesAndCargando } from '../../components/botones';
import { startCreateCuenta, startSavingCliente } from '../../../services';
import Swal from 'sweetalert2';
import { useModalStore } from '../../../stores';


const initCliente = {
    nombre: "",
    cedula: "",
    ciudad: "",
    direccion: "",
    movil: "",
    email: "",
    role: "CLIENTE",
};


export const FormCrearUsuarioVenta = ({ funcion }) => {


    const { modalFormToggle } = useModalStore();
    const [ formCliente, handleInputChange, reset ] = useForm( initCliente );
    const { nombre, cedula, ciudad, direccion, movil, email } = formCliente;
    const [cargando, setCargando] = useState(false)


    const  handleCrearCliente = async( e ) => {
        e.preventDefault();
        if([nombre, cedula, ciudad, direccion, movil, email ].includes('')){
            Swal.fire('Error', 'Todos los datos del formularion son obligatorios', 'error');
            return;
        }
        
        setCargando(true);
        const resp = await funcion(formCliente);
        setCargando(false);
        if( resp ){
            reset();
            modalFormToggle(false)
        }
    }



    return (
        <form  onSubmit={ handleCrearCliente } >
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        label="Nombre"
                        fullWidth
                        placeholder='Nombre'
                        name="nombre"
                        value={ nombre }
                        onChange={ handleInputChange }
                        size="small"                    >
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        label="Cedula"
                        fullWidth
                        placeholder="Cedula"
                        multiline
                        name="cedula"
                        value={ cedula }
                        onChange={ handleInputChange }
                        size="small" 
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        label="Email"
                        fullWidth
                        placeholder="Email"
                        multiline
                        name="email"
                        value={ email }
                        onChange={ handleInputChange }
                        size="small" 
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        label="Ciudad"
                        fullWidth
                        placeholder="Ciudad"
                        multiline
                        name="ciudad"
                        value={ ciudad }
                        onChange={ handleInputChange }
                        size="small" 
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        label="Dirección"
                        fullWidth
                        placeholder="Dirección"
                        multiline
                        name="direccion"
                        value={ direccion }
                        onChange={ handleInputChange } 
                        size="small"
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        label="Movil"
                        fullWidth
                        placeholder="Movil"
                        multiline
                        name="movil"
                        value={ movil }
                        onChange={ handleInputChange } 
                        size="small"
                    />
                </Grid>
            </Grid>

            <Grid container sx={{mb:2, mt:3, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo='Crear Usuario'
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>
        </form>
    )
}
